"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgPasswordShow(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M20 29c8.837 0 16-9.273 16-9.273S28.837 11 20 11 4 19.727 4 19.727 11.163 29 20 29z", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 20a6 6 0 11-4.233-5.736 3 3 0 103.969 3.97c.171.558.264 1.151.264 1.766z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgPasswordShow;
//# sourceMappingURL=PasswordShow.js.map